module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"Hello, {name}","helpYou":"How can we help you today?","pleaseWait":"Please wait...","businessProcess":"Business Process {bp}"},"es":{"hello":"Hola, {name}","helpYou":"Como podemos ayudarlo el dia de hoy?","pleaseWait":"Por favor espere...","businessProcess":"Proceso de negocio {bp}"}}')
  delete Component.options._Ctor
}
